// Service taxonomy for Screening Services Mobile.
// Each leaf has a unique flat code that gets stored in collector.services[].

export const SERVICE_TREE = [
  {
    key: "blood",
    label: "Blood Collection",
    code: "blood_collection",
  },
  {
    key: "bat",
    label: "BAT Testing",
    children: [
      { code: "bat_dot", label: "DOT" },
      { code: "bat_non_dot", label: "Non-DOT" },
    ],
  },
  {
    key: "drug",
    label: "Drug Testing",
    groups: [
      {
        key: "drug_dot",
        label: "DOT",
        children: [
          { code: "drug_dot_oral", label: "Oral" },
          { code: "drug_dot_urine", label: "Urine" },
        ],
      },
      {
        key: "drug_non_dot",
        label: "Non-DOT",
        children: [
          { code: "drug_non_dot_oral", label: "Oral" },
          { code: "drug_non_dot_urine", label: "Urine" },
          { code: "drug_non_dot_hair", label: "Hair" },
          { code: "drug_non_dot_nails", label: "Nails" },
        ],
      },
    ],
  },
];

export const SERVICE_LABELS = {
  blood_collection: "Blood Collection",
  bat_dot: "BAT · DOT",
  bat_non_dot: "BAT · Non-DOT",
  drug_dot_oral: "Drug · DOT · Oral",
  drug_dot_urine: "Drug · DOT · Urine",
  drug_non_dot_oral: "Drug · Non-DOT · Oral",
  drug_non_dot_urine: "Drug · Non-DOT · Urine",
  drug_non_dot_hair: "Drug · Non-DOT · Hair",
  drug_non_dot_nails: "Drug · Non-DOT · Nails",
};

export const ALL_SERVICE_CODES = Object.keys(SERVICE_LABELS);

const LEGACY_ALIASES = { dot_urine: "drug_dot_urine", blood_draw: "blood_collection", hair_collection: "drug_non_dot_hair" };

// Maps older free-text/legacy codes (e.g. "dot_urine", "blood draw") onto current taxonomy codes.
export const normalizeServiceCode = (code) => {
  const c = String(code || "").trim().toLowerCase().replace(/[\s-]+/g, "_");
  return LEGACY_ALIASES[c] || c;
};

export const labelFor = (code) =>
  SERVICE_LABELS[code] || SERVICE_LABELS[normalizeServiceCode(code)] || String(code).replace(/_/g, " ");
